<span
  *ngIf="pending"
  class="spinner-border spinner-border-sm me-2"
  aria-hidden="true"
></span>
<ng-content></ng-content>
